import { useMutation, useQueryClient } from '@tanstack/react-query';

import { changeUserPlan } from '../api/usersApi';
import { ADMIN_USERS_QUERY_KEY } from './useAdminUsers';
import type { ChangeUserPlanRequest } from '../../../api/types';

// PARA-137, AC-4: инвалидирует ['admin','users'] после успешной смены тарифа.
export function useChangeUserPlan() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, payload }: { userId: number; payload: ChangeUserPlanRequest }) =>
      changeUserPlan(userId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_USERS_QUERY_KEY });
    },
  });
}
